import { Tile, Stat, Empty } from "./Tile";
import { usd } from "../../lib/dash";

const CostTable = ({ testid, title, rows }) => (
  <div className="flex min-h-0 flex-col">
    <p className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{title}</p>
    {rows.length === 0 ? (
      <Empty testid={`${testid}-empty`}>No AI spend in this period.</Empty>
    ) : (
      <ul data-testid={testid} className="min-h-0 flex-1 overflow-y-auto pr-1">
        {rows.map((r) => (
          <li key={r.name} className="flex items-baseline justify-between gap-2 border-b border-border/60 py-1.5 text-[13px] last:border-0">
            <span className="truncate">{r.name}</span>
            <span className="shrink-0 tabular-nums text-muted-foreground">{r.calls} calls · <b className="text-foreground">{usd(r.usd)}</b></span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const BudgetBar = ({ budget }) => {
  const pct = Math.min(100, budget.used_pct ?? 0);
  const tone = budget.paused || pct >= 100 ? "bg-rose-500" : pct >= 80 ? "bg-amber-400" : "bg-emerald-500";
  return (
    <div data-testid="ai-budget" className="mt-3">
      <div className="flex justify-between text-[11px] text-muted-foreground">
        <span>Spend gate today: {usd(budget.spent_today_usd)} of {usd(budget.today_budget_usd)}</span>
        <span>{budget.paused ? "Paused" : budget.used_pct === null ? "No budget" : `${budget.used_pct}% · ${budget.mode}`}</span>
      </div>
      <div className="mt-1 h-2 overflow-hidden rounded-full bg-muted">
        <div className={`h-full rounded-full ${tone} transition-[width] duration-500`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export const AiCostsTile = ({ ai, tone, index }) => (
  <Tile id="ai-costs" index={index} tone={tone} kicker="Tile 1 · ledger estimates" title="AI costs">
    <div className="grid grid-cols-3 gap-2">
      <Stat testid="ai-today" label="Today" value={usd(ai.today_usd)} />
      <Stat testid="ai-week" label="Last 7 days" value={usd(ai.week_usd)} />
      <Stat testid="ai-month" label="This month" value={usd(ai.month_usd)} />
    </div>
    <BudgetBar budget={ai.budget} />
    <div className="mt-3 grid min-h-0 flex-1 grid-cols-2 gap-4">
      <CostTable testid="ai-by-provider" title={`By provider · ${ai.label}`} rows={ai.by_provider} />
      <CostTable testid="ai-by-step" title={`By step · ${ai.label}`} rows={ai.by_step} />
    </div>
    <p data-testid="ai-basis" className="mt-2 text-[11px] text-muted-foreground">
      {ai.basis}{ai.truncated ? " · only the newest 20,000 lines counted" : ""}
    </p>
  </Tile>
);
